import React from 'react';

import { Pressable, Text } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';
import { GestureResponderEvent, StyleSheet, View } from 'react-native';

import { MastercardPartnershipAlert } from 'pages/loyalty/loyalty-partners/mastercard/mastercard-partnership-alert';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { primitive } from 'styles/constants/primitives';

import { IPaymentMethodAddNewItemOptionProps } from './types';

export const PaymentMethodAddNewItemOption = ({
  text,
  Icon,
  onPress,
  testID,
  selected = false,
  isDisabled = false,
  showMastercardPartnership = false,
}: IPaymentMethodAddNewItemOptionProps) => {
  const handleOnPress = (e: GestureResponderEvent) => {
    if (!onPress) {
      return;
    }
    if (!selected) {
      logButtonClick({
        attributes: {
          Name: text,
          name: text,
          component: ClickEventComponentNames.BUTTON,
        },
      });
    }
    onPress(e);
  };

  return (
    <Pressable
      onPress={handleOnPress}
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={text}
    >
      <View style={styles.container}>
        <View style={styles.mainContent}>
          {Icon}
          <Text color={isDisabled ? primitive.$blackOpacity30 : primitive.bk.$bbqBrown}>
            {text}
          </Text>
        </View>
        {showMastercardPartnership && <MastercardPartnershipAlert short />}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: spacing['$13.5'],
    padding: primitive.spacing.$2,
    flexDirection: 'column',
    gap: primitive.spacing.$2,
    justifyContent: 'center',
  },
  mainContent: {
    gap: primitive.spacing.$2,
    flexDirection: 'row',
  },
});
